import api from '../NetworkService';

export const getTagsByType = type => api
    .getClient()
    .get(`/api/tags?type=${type}`)
    .then(response => response.data);
